// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "nav .social{padding:15px;width:100%}nav .social,nav .social a{background:#fff;position:relative;justify-content:center}nav .social a{z-index:1;margin-left:15px;display:inline-flex;align-items:center;width:40px;height:40px;box-shadow:0 0 24px 0 rgba(218,33,41,.2);color:#da291c;border-radius:100%}nav .social a svg path{fill:#f04740}nav .social a:first-of-type{margin:0}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
